import ApprovedScreen from 'features/believe/application/ApprovedScreen/ApprovedScreen';
import React from 'react';

// This is the new Believe Day 0 approved screen.
export default function Page() {
  return <ApprovedScreen />;
}
